module.exports = __webpack_public_path__ + "img/0009.29b89645.jpg";